export function escapeHtml(value = "") {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

export function replaceTemplateKeysWithPills(html = "", readOnly = false) {
  return String(html).replace(/\{\{\s*([^{}]+?)\s*\}\}/g, (_, key) => {
    const cleanKey = key.trim();
    const safeKey = escapeHtml(cleanKey);

    return `
      <span
        class="template-tag-pill"
        data-template-key="${safeKey}"
        contenteditable="false"
      >
        <span style="pointer-events:none;">
          ${safeKey}
        </span>

        ${
          readOnly
            ? ""
            : `
              <button
                type="button"
                tabindex="-1"
                data-template-tag-remove="true"
              >
                ×
              </button>
            `
        }
      </span>
    `;
  });
}

export function replacePillsWithTemplateKeys(html = "") {
  const parser = new DOMParser();
  const doc = parser.parseFromString(String(html), "text/html");

  doc.querySelectorAll("[data-template-key]").forEach((el) => {
    const key = el.getAttribute("data-template-key");
    el.replaceWith(doc.createTextNode(`{{${key}}}`));
  });

  return doc.body.innerHTML;
}

export function normalizeTag(tag) {
  if (typeof tag === "string") {
    return {
      label: tag,
      value: tag,
    };
  }

  return {
    label: tag.label ?? tag.name ?? tag.value,
    value: tag.value ?? tag.name ?? tag.label,
  };
}
